import { ClientStorageKey, StorageService } from '../../../../../../shared/services/storage/storage.service';
import { FINANCIAL_DASHBOARD_NEW_ROUTE, FINANCIAL_DASHBOARD_ROUTE } from './dashboard-route.const';

export const FINANCIAL_DASHBOARD_VERSION = {
    CURRENT: 'current',
    NEW: 'new',
} as const;

export type FinancialDashboardVersion = (typeof FINANCIAL_DASHBOARD_VERSION)[keyof typeof FINANCIAL_DASHBOARD_VERSION];

export function saveFinancialDashboardVersion(storage: StorageService, version: FinancialDashboardVersion): void {
    storage.setLocal(ClientStorageKey.FINANCIAL_DASHBOARD_VERSION, version);
}

export function savedFinancialDashboardRoute(storage: StorageService): string {
    const saved = storage.getLocal(ClientStorageKey.FINANCIAL_DASHBOARD_VERSION);
    if (saved === FINANCIAL_DASHBOARD_VERSION.CURRENT) {
        return FINANCIAL_DASHBOARD_ROUTE;
    }
    return FINANCIAL_DASHBOARD_NEW_ROUTE;
}
